module.exports = __webpack_public_path__ + "img/6.bcb7a506.jpg";